/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const WebAppCreateSocialUploadDtoSourceTypeEnum = {
    FRAGMENT: "FRAGMENT",
    VIDEO_EDITOR_EDIT: "VIDEO_EDITOR_EDIT"
} as const;

export type WebAppCreateSocialUploadDtoSourceTypeEnumKey = (typeof WebAppCreateSocialUploadDtoSourceTypeEnum)[keyof typeof WebAppCreateSocialUploadDtoSourceTypeEnum];

export type WebAppCreateSocialUploadDto = {
    /**
     * @description Whether the upload is for fragment media or a video-editor edit.
     * @type string
    */
    sourceType: WebAppCreateSocialUploadDtoSourceTypeEnumKey;
    /**
     * @description Fragment ID when sourceType is FRAGMENT, edit ID when VIDEO_EDITOR_EDIT.
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @description Platform-specific publish configuration
     * @type object
    */
    data: {
        [key: string]: any;
    };
    /**
     * @description Connection (profile) id to use. Must be assigned to the fragment/edit station. Platform is derived from the connection.
     * @type string, uuid
    */
    connectionId: string;
};